<template>
  <div class="">
    <div class="top">
      <NavTop1 activeIndex="1"></NavTop1>
    </div>
    <div class="content" v-loading="loading">
      <div class="" style="margin-left: 20px;">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane :label="item.name" :name="item.id" v-for="item in categoryList" :key="item.id"></el-tab-pane>
        </el-tabs>
      </div>
      <!-- 商品 -->
      <div class="goodsBox" style="display: flex;align-items: center;flex-wrap: wrap;">
        <div class="" v-for="(item, index) in list1" :key="index"
          style="width: 250px;margin-right: 13px;margin-bottom: 10px;" @mouseenter="current1 = item"
          @mouseleave="current1 = 0" @click="goDetail(item)">
          <div class=""
            style="width: 250px;border-radius: 10px 10px 0 0;height: 127px;display: block;position: relative;">
            <img :src="baseUrl +item.cover_image" alt=""
              style="width: 250px;border-radius: 10px 10px 0 0;height: 127px;display: block;">

            <div class=""
              style="background-color: #fa3434;color: #fff;position: absolute;top: 10px;right: 10px;padding: 0 4px;font-size: 12px;">
              <img src="../assets/images/live.gif" alt="" style="height: 10px;width: 10px;">
              Live
            </div>
            <img :src="item.home_img" alt="" style="height: 60px;width: 60px;position: absolute;top: 40px;left: 20px;"
              v-if="item.types == 3">
            <img :src="item.away_img" alt="" style="height: 60px;width: 60px;position: absolute;top: 40px;right: 20px;"
              v-if="item.types == 3">
            <div class=""
              style="position: absolute;top: 10px;left: 0;background-color: #218aff;color: #fff;padding: 0 3px;">推荐
            </div>
            <img src="../assets/imgs/play.png" alt=""
              style="height: 60px;width: 60px;position: absolute;top: 33px;left: 95px;" v-if="current1 == item">
          </div>
          <div class="" style="background-color: #fff;padding: 10px;">
            <div class="text-ellipsis">
              {{ item.title }}
            </div>
            <div class=""
              style="display: flex;align-items: center;justify-content: space-between;margin-top: 5px;font-size: 12px">
              <div class="" style="display: flex;align-items: center;;color: #777;">
                <img :src="baseUrl+item.user.avatar" alt=""
                  style="width: 20px;height: 20px;border-radius: 50%;margin-right: 2px;">
                {{ item.user.nickname }}
              </div>
              <div class="" style="display: flex;align-items: center;color: #777;">
                <img src="../assets/images/fire.png" alt="" style="width: 12px;height: 12px;margin-right: 2px;">
                {{ item.heat }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <!-- <div class="footer-box">
        <el-pagination background layout="prev, pager, next" :total="total" :current-page="page"
          @current-change="currenfChange"></el-pagination>
      </div> -->
    </div>
  </div>
</template>
<script>
import NavTop1 from '../components/NavTopWhit.vue'
import { getLivelist } from '../api/user'
export default {
  components: {
    NavTop1,

  },
  data() {
    return {
      activeName: '0',
      page: 1,
      total: 0,
      categoryList: [{ name: '全部' }, { name: '足球' }, { name: '篮球' }, { name: '其他' }],
      cateId: '0',
      current1: 0,
      list1: [],
      loading: false

    }
  },
  created() {
    this.getlist()
  },
  methods: {
    handleClick(e) {
      console.log(e.index);
      this.current = e.index

      this.getlist()
    },
    goDetail(item) {
      if (item.types == 3) {
        // 原始流
        this.$router.push({
          path: '/detailNew',
          query: {
            id: item.id
          }
        })
      } else {
        // 原始流
        this.$router.push({
          path: '/details',
          query: {
            id: item.id
          }
        })

      }
    },
    getlist() {
      this.loading = true
      getLivelist({
        game_type: this.current
      }).then(res => {
        this.loading = false
        this.list1 = res.data.data
      })
    },
    currenfChange(e) {
      console.log(e);
      this.page = e
      this.getlist()
    },
  }
}
</script>
<style scoped>
.content {
  width: 1320px;
  margin: 110px auto 0;
  min-height: 700px;
}

/deep/.el-tabs__item.is-active {
  color: #000 !important;
  font-weight: bold;
}

/deep/.el-tabs__nav-wrap::after {
  background-color: #fafafa;
}

/deep/.el-tabs__active-bar {
  background-color: #4b72f6;
  height: 5px;
  border-radius: 60px;
}

/deep/.el-tabs__item:hover {
  color: #4b72f6 !important;
}

.goods-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}

.footer-box {
  display: flex;
  justify-content: center;
  margin: 30px 0;
}

/deep/ .footer-box .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4b72f6 !important;
}

/deep/.footer-box .el-pagination.is-background .el-pager li {
  background-color: #fff !important;
  border: 1px solid #D9D9D9;
}

.goodsBox div:nth-child(5n) {
  margin-right: 0 !important;
}

/deep/.el-tabs__item {
  font-size: 18px;
  color: #666;
}

/deep/.el-tabs__item.is-active {
  font-size: 24px;
}

/deep/[data-v-63b599e7] .el-tabs__nav-wrap::after {
  background-color: transparent;
}
</style>